import { Observable } from 'rxjs';
import { ofType } from 'redux-observable';

import { delay, map } from 'rxjs/operators';
import { Actions } from '../../actions';

import {
  HideToastNotification,
  ShowToastNotification,
} from '../action-creators';
import { SHOW_TOAST_NOTIFICATION } from '../actions';

export const HideToastNotificationEpic = (action$: Observable<Actions>) =>
  action$.pipe(
    ofType<Actions, ShowToastNotification>(SHOW_TOAST_NOTIFICATION),
    delay(3000),
    map(() => {
      return new HideToastNotification();
    })
  );
